import { DomSanitizer } from '@angular/platform-browser'
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'safeURL',
})
export class SafeURLPipe implements PipeTransform {

    constructor(private domSanitizer: DomSanitizer) { }

    transform(url: string) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url)
    }
}
